import { create } from 'zustand';

import { IUserResponse } from 'types/user';

interface IUserStore {
  user: IUserResponse | null;
  setUser: (user: IUserResponse | null) => void;
}

export const useUserStore = create<IUserStore>(set => ({
  user: null,
  setUser: user => set({ user }),
}));
